/**
 * Ruta pública (canónica) del perfil de un abogado.
 * Usa el slug (/abogado/perfil/{slug}) si está disponible; si no, cae al UUID
 * (/lawyer/{id}/profile), que en el server hace 301 al slug cuando exista.
 */
export const getLawyerProfilePath = (lawyer?: { id?: string; slug?: string | null } | null): string => {
    if (lawyer?.slug) return `/abogado/perfil/${lawyer.slug}`;
    return `/lawyer/${lawyer?.id ?? ''}/profile`;
};

export const getInitials = (name: string, lastName: string, phone?: string | null) => {
    const firstInitial = name?.trim()?.charAt(0).toUpperCase() || '';
    const lastInitial = lastName?.trim()?.charAt(0).toUpperCase() || '';
    
    // Si no hay nombre y apellido, usar teléfono o fallback
    if (!firstInitial && !lastInitial) {
        if (phone) {
            // Usar los últimos 2 dígitos del teléfono
            return phone.slice(-2).toUpperCase();
        }
        return 'CA'; // Contacto Anónimo
    }
  
    return `${firstInitial}${lastInitial}`;
};

export const getUserDisplayName = (name: string, lastName: string, phone?: string | null) => {
    if (name && lastName) {
        return `${name} ${lastName}`;
    }
    return phone || 'Contacto anónimo';
};

export const truncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) {
        return text;
    }
    return text.slice(0, maxLength) + '...';
};

export function isValidEmail(email: unknown): boolean {
  if (typeof email !== 'string') return false;

  const trimmed = email.trim();
  if (trimmed === '') return false;

  // Validación básica de email con RegExp
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(trimmed);
}
